import { PerformancePort } from '../../ports'

export const performanceBrowserAdapter: PerformancePort = {
  mark: (metricName: string): PerformanceMark =>
    window.performance.mark(metricName),
  getEntriesByName: (name: string): PerformanceEntryList =>
    window.performance.getEntriesByName(name),
}
